import * as React from 'react';
import { Box, Typography, Container, Button } from '@mui/material';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { HiPlay } from 'react-icons/hi';

export default function CTASection() {
  const navigate = useNavigate();

  return (
    <Box sx={{ position: 'relative', py: { xs: 10, md: 16 }, background: '#050505' }}>
      <Container maxWidth="md" sx={{ textAlign: 'center' }}>
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-100px' }}
          transition={{ duration: 0.6 }}
        >
          <Box
            sx={{
              p: { xs: 4, md: 8 },
              borderRadius: 6,
              background: 'linear-gradient(135deg, rgba(139,92,246,0.08) 0%, rgba(0,180,216,0.05) 50%, rgba(236,72,153,0.08) 100%)',
              border: '1px solid rgba(139,92,246,0.15)',
              position: 'relative',
              overflow: 'hidden',
              '&::before': {
                content: '""',
                position: 'absolute',
                inset: 0,
                background: 'radial-gradient(ellipse at 30% 50%, rgba(139,92,246,0.1) 0%, transparent 60%), radial-gradient(ellipse at 70% 50%, rgba(236,72,153,0.08) 0%, transparent 60%)',
                pointerEvents: 'none',
              },
            }}
          >
            <Box sx={{ position: 'relative', zIndex: 1 }}>
              <Typography
                sx={{
                  fontSize: { xs: '0.8rem', md: '0.875rem' },
                  fontWeight: 600,
                  color: '#8B5CF6',
                  textTransform: 'uppercase',
                  letterSpacing: '0.1em',
                  mb: 2,
                }}
              >
                Get Started Now
              </Typography>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { xs: '1.75rem', md: '2.75rem' },
                  fontWeight: 800,
                  letterSpacing: '-0.02em',
                  mb: 3,
                  lineHeight: 1.2,
                }}
              >
                Ready to dive into{' '}
                <Box
                  component="span"
                  sx={{
                    background: 'linear-gradient(135deg, #8B5CF6, #00B4D8)',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                    backgroundClip: 'text',
                  }}
                >
                  endless anime?
                </Box>
              </Typography>
              <Typography
                sx={{
                  color: '#94A3B8',
                  fontSize: { xs: '0.95rem', md: '1.1rem' },
                  maxWidth: 480,
                  mx: 'auto',
                  mb: 5,
                  lineHeight: 1.7,
                }}
              >
                No sign-up required. Start watching your favorite anime instantly.
              </Typography>
              <Button
                variant="contained"
                size="large"
                onClick={() => navigate('/home')}
                startIcon={<HiPlay size={22} />}
                sx={{
                  background: 'linear-gradient(135deg, #8B5CF6, #7C3AED)',
                  color: '#fff',
                  fontWeight: 700,
                  fontSize: '1.05rem',
                  px: 5,
                  py: 2,
                  borderRadius: 3,
                  textTransform: 'none',
                  boxShadow: '0 8px 32px rgba(139,92,246,0.35)',
                  '&:hover': {
                    background: 'linear-gradient(135deg, #9C6CF7, #8B4DEA)',
                    boxShadow: '0 12px 40px rgba(139,92,246,0.5)',
                    transform: 'translateY(-2px)',
                  },
                }}
              >
                Start Watching Free
              </Button>
            </Box>
          </Box>
        </motion.div>
      </Container>
    </Box>
  );
}
